<template>
    <!-- 购票进度 -->
    <div class="schedule">
        <div class="title">{{$t('TicketingProcessObj.TicketingProcess')}}</div>
        <div class="content">
        <div class="block">
            <el-timeline>
            <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :class="[activitiesIndex - 1 > index ? 'timeline-line-animation' : '']"
                :color="activitiesIndex > index ? activity.color : null">
                <img v-if="(activitiesIndex - 1 === index) &&  activitiesIndex < 6" class="dynamicFuzzy" src="../assets/images/home/dynamicFuzzy.gif" />
                <span :class="[activitiesIndex > index ?'activity':'']">{{activity.content}}</span>
            </el-timeline-item>
            </el-timeline>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            activities: [
                {
                content: this.$t('TicketingProcessObj.TicketingProcess'),
                color: '#853D3F'
                },
                {
                content: this.$t('TicketingProcessObj.TimeOut'),
                color: '#853D3F'
                },
                {
                content: this.$t('TicketingProcessObj.selectTicketType'),
                color: '#853D3F'
                },
                {
                content: this.$t('TicketingProcessObj.FillOrder'),
                color: '#853D3F'
                },
                {
                content: this.$t('TicketingProcessObj.OrderPayment'),
                color: '#853D3F'
                },
                {
                content:  this.$t('TicketingProcessObj.Completed'),
                color: '#853D3F'
                }
            ]
        }
    },
    props:['activitiesIndex','text'],
    created() {
        if (this.text) {
            this.activities[5].content = this.text
        }
    }
}
</script>

<style lang="scss" scoped>
.schedule {
    position: absolute;
    right: -185px;
    top: 0;
    .title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 165px;
    height: 40px;
    background: #853D3F;
    color: #FFFFFF;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    }
    .content {
    padding: 16px 16px;
    background: white;
    padding-right: 0;
    .activity {
        color: #853D3F;
    }
    }
}
/deep/ .el-timeline-item {
    max-width: 148px;
}
/deep/ .el-timeline-item__tail {
  width: 5px;
}
.dynamicFuzzy {
  width: 25px;
  position: absolute;
  left: -7px;
  top: 14px;
}
/deep/.timeline-line-animation .el-timeline-item__tail:after {
  content: "";
  display: inline-block;
  width: 50%;
  height: 100%;
  background: #853D3F; /* Old browsers */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2989d8', endColorstr='#2989d8',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
  background-size: 60px 30px;
  text-align: center;
  color:#fff;
  -webkit-animation:load 0.5s ease-in; //infinite
  position: absolute;
  top: 0;
  left: -40%;
}
@-webkit-keyframes load{
    0%{
      height: 0%;
    }
    100%{
      height:100%;
    }
}
</style>